<template>
	<ul class="socials main__socials" style="margin-right: 0;">
	    <li class="social" style="margin-right: 0;"><a href="javascript:void(0)" v-on:click="shareMedia('facebook');"><img :src="data.src_fb"></a></li>
	    <li class="social" style="margin-right: 0;"><a href="javascript:void(0)" v-on:click="shareMedia('whatapps');"><img :src="data.src_wasap"></a></li>
	    <li class="social" style="margin-right: 0;"><a href="javascript:void(0)" v-on:click="shareMedia('telegram');"><img :src="data.src_tele"></a></li>
	</ul>
</template>

<script>
	export default {
		props: ['data'],
		data() {
			return {
				url_fb: "https://www.facebook.com/sharer/sharer.php?u=" + this.data.post.url,
				url_wasap: "https://wa.me/?text=" + this.data.post.url,
				url_tele: "https://telegram.me/share/url?url=" + this.data.post.url,
			};
		},
		mounted() {
		},
		methods: {
    		shareMedia(type) {
    			const form = new FormData();
    			form.append('type', type);
    			form.append('post_id', this.data.post.id);
    			axios.post('/api/ajax/posts/hit', form)
    			.then(res => {
	    			if (type == 'facebook') {
		    			window.open(this.url_fb, '_blank');
	    			}
	    			if (type == 'whatapps') {
		    			window.open(this.url_wasap, '_blank');
	    			}
	    			if (type == 'telegram') {
		    			window.open(this.url_tele, '_blank');
	    			}
    		    })
    		    .catch(err => {  
    		    	console.log(err);                  
    		    }); 
    		},
		},
		computed: {
		},   
	}
</script>

